export const appColors = {
  primary: '#0ACD9A',
  black: '#020618',
  gray: '#cfcfcf',
  disabledText: '#62748E',
  disabledBg: '#F8F8F8',
  placeholder: '#62748E',
  white: '#fff',
  green: '#05cd56',
  orange: '#FF9500',
  yellow: '#ffd60a',
  red: '#ff4d4f',
  blue: '#007AFF',
  waiting: '#FF9500',
  bg: '#f6f6f6',
  content: '#fff',
  stroke: '#E2E8F0',
  gr: '#0ACD9A',
};
